import { render, staticRenderFns } from "./Nested-Sheet-Simple-Table.vue?vue&type=template&id=6200fd3e&lang=pug"
import script from "./Nested-Sheet-Simple-Table.vue?vue&type=script&lang=ts"
export * from "./Nested-Sheet-Simple-Table.vue?vue&type=script&lang=ts"
import style0 from "./Nested-Sheet-Simple-Table.vue?vue&type=style&index=0&id=6200fd3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports